<template>
	<core-modal
		name="bulk-trash-modal"
		class="omapi-modal bulk-trash-modal"
		:clickToClose="!isBulkTrashing"
		:isConfirmation="true"
	>
		<modals-content>
			<form @submit.prevent="bulkTrash">
				<p>Are you sure you want to trash {{ bulk.length }} {{ makePlural('campaign', bulk.length) }}.</p>

				<section class="buttons">
					<core-loading-button
						class="bulk-trash-campaign"
						size="large"
						color="blue"
						buttonType="submit"
						:loading="isBulkTrashing"
						ref="toFocus"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						@click.prevent="$modal.hide('bulk-trash-modal')"
						:disabled="isBulkTrashing"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { trash } from '@/campaigns/mixins/trash'
import { strings } from '@/campaigns/mixins/strings'

export default {
	mixins : [ trash, strings ],
}
</script>

<style lang="scss">
.bulk-trash-modal {

}
</style>
